export default [
  {
      path: '/rent/v2/camper',
      name: 'camperIndex',
      component: () => import('@/pages/camper/index'),
      meta: { title: '营地', requireAuth: true },
      children: [
        {    
          path: 'camperList',
          name: 'camperList',
          component: () => import('@/pages/camper/camperList'),
          meta: { title: '营地列表', requireAuth: false },
        },
        {    
          path: 'searchProduct',
          name: 'searchProduct',
          component: () => import('@/pages/camper/searchProduct'),
          meta: { title: '营地搜索', requireAuth: false },
        },
        {    
          path: 'chooseTime',
          name: 'chooseTime',
          component: () => import('@/pages/camper/chooseTime'),
          meta: { title: '选择日期', requireAuth: false },
        },
        {    
          path: 'camperDetail',
          name: 'camperDetail',
          component: () => import('@/pages/camper/camperDetail'),
          meta: { title: '营地详情', requireAuth: true },
        },
        {
          path: 'sdzMap',
          name: 'sdzMap',
          component: () => import('@/pages/camper/sdzMap'),
          meta: { title: '营地', requireAuth: false },
        },
        {
          path: 'orderCoupons',
          name: 'sdzOrderCoupons',
          component: () => import('@/pages/camper/orderCoupons'),
          meta: { title: '选择优惠券', requireAuth: true },
        },
        {
        path: 'chooseCity',
        name: 'chooseCity',
        component: () => import('@/pages/camper/chooseCity'),
        meta: { title: '城市选择', requireAuth: false },
        },
        {
        path: 'camperInput',
        name: 'camperInput',
        component: () => import('@/pages/camper/camperInput'),
        meta: { title: '水电桩号输入', requireAuth: true },
        },
        {
        path: 'camperDispatch',
        name: 'camperDispatch',
        component: () => import('@/pages/camper/camperDispatch'),
        meta: { title: '水电桩号分配', requireAuth: true },
        },
        {
          path: 'orderCancel',
          name: 'orderCancel',
          component: () => import('@/pages/camper/orderCancel'),
          meta: { title: '取消原因', requireAuth: false },
        },
        {
          path: 'replaceReason',
          name: 'replaceReason',
          component: () => import('@/pages/camper/replaceReason'),
          meta: { title: '更换原因', requireAuth: false },
        },
        {
          path: 'QRCode',
          name: 'QRCode',
          component: () => import('@/pages/camper/QRCode'),
          meta: { title: '二维码扫描', requireAuth: false },
        },
        {
          path: 'control',
          name: 'control',
          component: () => import('@/pages/camper/control'),
          meta: { title: '控制器', requireAuth: false },
        },
        {
          path: 'faultReport',
          name: 'faultReport',
          component: () => import('@/pages/camper/camperFaultReport'),
          meta: { title: '故障上报', requireAuth: false },
        },
        {    
          path: 'camperRule',
          name: 'camperRule',
          component: () => import('@/pages/camper/camperRule'),
          meta: { title: '规则说明', requireAuth: false },
        },
        {    
          path: 'ydComment',
          name: 'ydComment',
          component: () => import('@/pages/camper/postComment'),
          meta: { title: '营地评价', requireAuth: false },
        },
      ]
  },
  {
    path: '/sdz/detail',
    name: 'campingSiteReserve',
    component: () => import('@/pages/camper/campingSiteReserve'),
    meta: { title: '营位详情', requireAuth: true },
  },
]


// WEBPACK FOOTER //
// ./src/pages/camper/camper.js